/**
 * 存储数据
 */
export const setItemLocal = (key, value) => {
    // 将数组、对象类型的数据转换为 JSON 格式字符串进行存储
    if (typeof value === 'object') {
        value = JSON.stringify(value)
    }
    window.localStorage.setItem(key, value)
}

/**
 * 存储数据
 */
export const setItem = (key, value) => {
    // 将数组、对象类型的数据转换为 JSON 格式字符串进行存储
    if (typeof value === 'object') {
        value = JSON.stringify(value)
    }
    window.localStorage.setItem(key, value)
}

/**
 * 获取数据
 */
export const getItem = key => {
    const data = window.localStorage.getItem(key)
    try {
        if (data.indexOf('[') === 0 || data.indexOf('{') === 0) {
            return JSON.parse(data)
        } else {
            return data
        }
    } catch (err) {
        return data
    }
}

/**
 * 获取数据
 */
export const getItemLocal = key => {
    const data = window.localStorage.getItem(key)
    try {
        return JSON.parse(data)
    } catch (err) {
        return data
    }
}

/**
 * 删除数据
 */
export const removeItem = key => {
    window.sessionStorage.removeItem(key)
}

/**
 * 删除数据
 */
export const removeItemLocal = key => {
    window.sessionStorage.removeItem(key)
}
